import { get, isEmpty } from 'ui/lodash';
import SnackBar from 'ui/services/snackbar';
import { injectJS } from 'ui/lib/loadJs';

export const handleRazorpay = async (shop, data, helpers) => {
  await injectJS('razorpay', 'https://checkout.razorpay.com/v1/checkout.js');
  const theme = get(shop, 'config.themeColor', '#F5603F');
  const icon = get(shop, 'icon', []);
  const emptyShop = '/images/logo.svg';
  const shopIcon = isEmpty(icon) ? emptyShop : icon[0] || emptyShop;
  const options = {
    amount: data.amount,
    currency: 'INR',
    name: shop?.name || 'Windo',
    description: 'Buy',
    image: shopIcon,
    order_id: data.pgTid,
    theme: {
      color: theme
    },
    handler: () => {
      helpers.redirect(data.id, data.pgTid);
    },
    modal: {
      ondismiss: () => {
        SnackBar.showError('Payment cancelled');
      }
    },
    prefill: {
      name: data?.name,
      email: data?.email,
      contact: data?.phone
    },
    key: data.key,
  };

  const rzp = new window.Razorpay(options);
  rzp.on('payment.failed', (res)=> {
    SnackBar.showError(res?.error?.description)
  });
  rzp.open();
};
